import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Oct 29 2020
 * @author ICe
 * @author JPk
 */
import * as React from 'react';
import { WorkflowCasesLayer } from '../../../shared/transportLayers/workflow-cases/WorkflowCasesLayer';
import debounce from 'lodash/debounce';
var DEFAULT_INTERVAL_DELAY = 60 * 1000; // 60 seconds

var WorkflowCasesLockHeartbeat =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WorkflowCasesLockHeartbeat, _React$Component);

  function WorkflowCasesLockHeartbeat() {
    var _this;

    _classCallCheck(this, WorkflowCasesLockHeartbeat);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WorkflowCasesLockHeartbeat).apply(this, arguments));
    _this.workflowCasesLayer = new WorkflowCasesLayer();
    _this.watchDelay = (_this.props.config || {}).intervalDelay || DEFAULT_INTERVAL_DELAY;

    _this.refreshLock = function () {
      _this.workflowCasesLayer.refreshLock(_this.props.caseIds);
    };

    _this.activityListener = debounce(_this.refreshLock, _this.watchDelay, {
      maxWait: _this.watchDelay,
      leading: true,
      trailing: false
    });
    return _this;
  }

  _createClass(WorkflowCasesLockHeartbeat, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      document.addEventListener('mousemove', this.activityListener);
      document.addEventListener('mousedown', this.activityListener);
      document.addEventListener('keydown', this.activityListener);
      document.addEventListener('scroll', this.activityListener);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousemove', this.activityListener);
      document.removeEventListener('mousedown', this.activityListener);
      document.removeEventListener('keydown', this.activityListener);
      document.removeEventListener('scroll', this.activityListener);
      this.activityListener.cancel();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return WorkflowCasesLockHeartbeat;
}(React.Component);

export default WorkflowCasesLockHeartbeat;